import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import mapTheme from './MapZoomControl.scss';
import { translate } from 'react-i18next';

class MapZoomControl extends PureComponent {
    componentDidMount() {
        const { map } = this.props;
        if (map) {
            map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(
                this.controls
            );
        }
    }

    getRef = ref => {
        this.controls = ref;
    };

    handleZoomIn = () => {
        const { map, setMapZoom } = this.props;
        if (!map) {
            return;
        }
        setMapZoom(map.getZoom() + 1);
    };

    handleZoomOut = () => {
        const { map, setMapZoom } = this.props;
        if (!map) {
            return;
        }
        setMapZoom(map.getZoom() - 1);
    };

    render() {
        const {
            positionControlsToLeft,
            disableControlsUI,
            isV2UI,
            t,
            theme
        } = this.props;
        if (disableControlsUI) {
            return null;
        }
        return (
            <div
                className={classnames(
                    mapTheme.zoomContainer,
                    theme.zoomContainer,
                    {
                        [mapTheme.newUI]: isV2UI,
                        [mapTheme.left]: positionControlsToLeft
                    }
                )}
            >
                <div
                    className={classnames(
                        mapTheme.controls,
                        mapTheme.zoomControl
                    )}
                    ref={this.getRef}
                >
                    <button title={t('mapZoomIn')} onClick={this.handleZoomIn}>
                        +
                    </button>
                    <div className={mapTheme.divider} />
                    <button
                        title={t('mapZoomOut')}
                        onClick={this.handleZoomOut}
                    >
                        −
                    </button>
                </div>
            </div>
        );
    }
}

export default themr(
    'MapZoomControl',
    mapTheme
)(translate('translations')(MapZoomControl));
